<template>
  <div :class="gridClasses">
    <StatCard
      v-for="(stat, index) in stats"
      :key="index"
      :label="stat.label"
      :value="stat.value"
      :subtext="stat.subtext"
      :icon-path="stat.iconPath"
      :colors="stat.colors"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import StatCard from './StatCard.vue'

const props = defineProps({
  stats: {
    type: Array,
    required: true,
    validator: (value) => {
      return value.every(stat => 
        stat.label && 
        (stat.value !== undefined && stat.value !== null) && 
        stat.iconPath && 
        stat.colors
      )
    }
  },
  columns: {
    type: [Number, Object],
    default: () => ({ base: 1, md: 2, lg: 5 }),
    validator: (value) => {
      if (typeof value === 'number') {
        return value >= 1 && value <= 12
      }
      // If object, validate it has proper structure
      if (typeof value === 'object') {
        return true
      }
      return false
    }
  },
  gap: {
    type: String,
    default: '6',
    validator: (value) => ['2', '3', '4', '5', '6', '8'].includes(value)
  }
})

const gridClasses = computed(() => {
  const classes = ['grid']
  
  // Handle columns
  if (typeof props.columns === 'number') {
    // Simple number - use same for all breakpoints
    classes.push(`grid-cols-1 md:grid-cols-2 lg:grid-cols-${props.columns}`)
  } else {
    // Object with breakpoint-specific columns
    const { base = 1, sm = null, md = 2, lg = 5, xl = null, '2xl': xxl = null } = props.columns
    classes.push(`grid-cols-${base}`)
    if (sm) classes.push(`sm:grid-cols-${sm}`)
    if (md) classes.push(`md:grid-cols-${md}`)
    if (lg) classes.push(`lg:grid-cols-${lg}`)
    if (xl) classes.push(`xl:grid-cols-${xl}`)
    if (xxl) classes.push(`2xl:grid-cols-${xxl}`)
  }
  
  // Add gap
  classes.push(`gap-${props.gap}`)
  
  return classes.join(' ')
})
</script>

